"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodOption = exports.PaymentMethods = exports.PaymentMethod = void 0;
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod[PaymentMethod["Cash"] = 0] = "Cash";
    PaymentMethod[PaymentMethod["Online"] = 1] = "Online";
    PaymentMethod[PaymentMethod["Partner"] = 2] = "Partner";
    PaymentMethod[PaymentMethod["StatementOfBooking"] = 3] = "StatementOfBooking";
    PaymentMethod[PaymentMethod["Unspecified"] = 99] = "Unspecified";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
exports.PaymentMethods = {
    Cash: PaymentMethod.Cash,
    Online: PaymentMethod.Online,
    Partner: PaymentMethod.Partner,
    StatementOfBooking: PaymentMethod.StatementOfBooking,
    Unspecified: PaymentMethod.Unspecified,
};
var PaymentMethodOption;
(function (PaymentMethodOption) {
    PaymentMethodOption[PaymentMethodOption["Cash"] = 0] = "Cash";
    PaymentMethodOption[PaymentMethodOption["Online"] = 1] = "Online";
    PaymentMethodOption[PaymentMethodOption["Partner"] = 2] = "Partner";
    PaymentMethodOption[PaymentMethodOption["StatementOfBooking"] = 3] = "StatementOfBooking";
    PaymentMethodOption[PaymentMethodOption["ApplePay"] = 4] = "ApplePay";
    PaymentMethodOption[PaymentMethodOption["GooglePay"] = 5] = "GooglePay";
    PaymentMethodOption[PaymentMethodOption["Alipay"] = 6] = "Alipay";
})(PaymentMethodOption || (exports.PaymentMethodOption = PaymentMethodOption = {}));
//# sourceMappingURL=PaymentMethod.js.map